import { render, staticRenderFns } from "./LoanStatus.vue?vue&type=template&id=000d6058&scoped=true&"
import script from "./LoanStatus.vue?vue&type=script&lang=js&"
export * from "./LoanStatus.vue?vue&type=script&lang=js&"
import style0 from "./LoanStatus.vue?vue&type=style&index=0&id=000d6058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000d6058",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
